import { TableHead, TableRow, TableCell, Box } from '@mui/material'

const HierarchicalTableHeader = () => {

  return (
    <TableHead className='pagesTableHeader'>
      <TableRow>
        <TableCell className='pagesTableHeaderCell pageHierarchicalUrl'>
          <Box className="pagesTableHeaderCellContent">URL</Box>
        </TableCell>
        <TableCell className='pagesTableHeaderCell pageHierarchicalDate'>
          <Box className="pagesTableHeaderCellContent">Last Discovery Date</Box>
        </TableCell>
        <TableCell className='pagesTableHeaderCell pageHierarchicalDate'>
          <Box className="pagesTableHeaderCellContent">Last Scan Date</Box>
        </TableCell>
        <TableCell className='pagesTableHeaderCell pageHierarchicalTests'>
          <Box className="pagesTableHeaderCellContent">UI Tests</Box>
        </TableCell>
        <TableCell className='pagesTableHeaderCell pageHierarchicalTestCases'>
          <Box className="pagesTableHeaderCellContent">Test Cases</Box>
        </TableCell>
        <TableCell className='pagesTableHeaderCell pageHierarchicalActions'>
          <Box className="pagesTableHeaderCellContent">Actions</Box>
        </TableCell>
      </TableRow>
    </TableHead>
  )
}

export default HierarchicalTableHeader